module.exports = __webpack_public_path__ + "img/alipay.d0e7a113.png";